import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654017cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Your membership plan", -1))
const _hoisted_3 = {
  key: 0,
  class: "subscription-subtext"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.getProductName()) + ": " + _toDisplayString(_ctx.getPricePer()) + " ", 1),
      (_ctx.userSubscription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(`For ${
            5 * (_ctx.getSubscriptionQuantity(_ctx.userSubscription) || 1)
          } workspaces (${_ctx.getSubscriptionQuantity(_ctx.userSubscription) || 1})`), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createElementVNode("button", {
          class: "button-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/payments')))
        }, " Change Plan ")
      ])
    ])
  ]))
}